import React, { useContext, useRef, useState, useEffect } from 'react';
import { NavbarContext } from './NavbarContext.js';
import { StyledMobileMenu, StyledMobileMenuPanel } from './Navbar.styles.js';
import ProfileIcon from './ProfileIcon.js';
import NavbarMobileNotifications from './NavbarMobileNotifications.js';
import NavbarMobileMenuItem from './NavbarMobileMenuItem.js';
import NavbarMobileMenuToggleButton from './NavbarMobileMenuToggleButton.js';
import NavbarMobileHelpItem from './NavbarMobileHelpItem.js';
import NavbarMobileMenuNotificationToggleButton from './NavbarMobileMenuNotificationToggleButton.js';

/* eslint-disable max-len */
const NavbarMobileMenu = () => {
    const { navItems, helpUrl, helpTarget, userMenuItems, helpMenuItems, location, isDark, notificationMenuItems, navbarLinkWrapper, helpItemLinkWrapper, userMenuLinkWrapper, userInfo, dropdownsExpandedByDefault, showMobileMenu, setShowMobileMenu, showMobileNotifications, setShowMobileNotifications, setShowMobileApplicationSwitcher, hasNotificationMenu, hasBody, customMobileMenu, helpMenuLocation, userMenuLocation, hideHelpMenuHeader } = useContext(NavbarContext);
    const toggleMenuButton = useRef(null);
    const toggleNotificationsButton = useRef(null);
    const [subMenusVisible, setSubMenusVisible] = useState([]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const menuItems = useRef([]);
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            if (showMobileMenu) {
                setShowMobileMenu(false);
                if (toggleMenuButton && toggleMenuButton.current) {
                    toggleMenuButton.current.focus();
                }
            }
            if (showMobileNotifications) {
                setShowMobileNotifications(false);
                if (toggleNotificationsButton && toggleNotificationsButton.current) {
                    toggleNotificationsButton.current.focus();
                }
            }
        }
    };
    const toggleSubMenu = (item) => {
        let copyOfMenuVisible = [...subMenusVisible];
        if (copyOfMenuVisible.indexOf(item.label) === -1) {
            copyOfMenuVisible.push(item.label);
        }
        else {
            copyOfMenuVisible = copyOfMenuVisible.filter((menuItem) => menuItem !== item.label);
        }
        setSubMenusVisible(copyOfMenuVisible);
    };
    useEffect(() => {
        if (showMobileMenu && menuItems.current && menuItems.current[0] && menuItems.current[0].focus) {
            menuItems.current[0].focus();
        }
        else {
            menuItems.current = [];
        }
    }, [showMobileMenu]);
    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [showMobileMenu, showMobileNotifications]);
    const checkIfDropdownsExpandedByDefault = (label) => {
        return dropdownsExpandedByDefault ? subMenusVisible.indexOf(label) === -1 : subMenusVisible.indexOf(label) > -1;
    };
    const toggleMobileMenuPanel = () => {
        setShowMobileMenu(!showMobileMenu);
        setShowMobileNotifications(false);
        setShowMobileApplicationSwitcher(false);
    };
    const toggleNotificationMenu = () => {
        setShowMobileNotifications(!showMobileNotifications);
        setShowMobileMenu(false);
        setShowMobileApplicationSwitcher(false);
    };
    useEffect(() => {
        navItems.map((menuItem) => {
            if (menuItem.menuItems) {
                menuItem.menuItems.map((subItem) => {
                    if (subItem.url && subItem.url === location) {
                        setSubMenusVisible((prev) => {
                            if (menuItem.label && prev.indexOf(menuItem.label) === -1) {
                                prev.push(menuItem.label);
                            }
                            else {
                                return prev.filter((item) => item !== menuItem.label);
                            }
                            return prev;
                        });
                    }
                });
            }
        });
    }, [navItems, location]);
    if (navItems.length > 0 || userMenuItems.length > 0 || helpMenuItems.length > 0 || helpUrl)
        return (React.createElement(StyledMobileMenu, { "data-lwt-id": 'navbar-mobile-menu', "$hasNavItems": navItems.length > 0 || hasBody },
            hasNotificationMenu && (React.createElement(NavbarMobileMenuNotificationToggleButton, { ref: toggleNotificationsButton, menuOpen: showMobileNotifications, setMenuOpen: toggleNotificationMenu })),
            React.createElement(NavbarMobileMenuToggleButton, { ref: toggleMenuButton, menuOpen: showMobileMenu, setMenuOpen: toggleMobileMenuPanel }),
            showMobileNotifications && (React.createElement(StyledMobileMenuPanel, { "$isDark": isDark },
                React.createElement(NavbarMobileNotifications, null))),
            showMobileMenu && (React.createElement(StyledMobileMenuPanel, { "$isDark": isDark },
                React.createElement(React.Fragment, null,
                    customMobileMenu && customMobileMenu,
                    navItems.map((item, navItemIndex) => (React.createElement(React.Fragment, { key: `mobile-nav-item-nav-item-${navItemIndex}` },
                        React.createElement("div", { className: `helix-unified-navbar__mobile-menu-item ${item.disabled ? 'disabled' : ''} ${item.menuItems ? 'helix-unified-navbar__mobile-menu-item-dropdown' : ''} ${item.url === location ? 'active' : ''}` },
                            React.createElement(NavbarMobileMenuItem, { isOpen: checkIfDropdownsExpandedByDefault(item.label), linkWrapper: navbarLinkWrapper, ref: (ref) => {
                                    if (menuItems.current && menuItems.current.indexOf(ref) === -1 && ref) {
                                        menuItems.current.push(ref);
                                    }
                                }, onClick: () => toggleSubMenu(item), location: location, item: item })),
                        item.menuItems &&
                            checkIfDropdownsExpandedByDefault(item.label) &&
                            item.menuItems.map((menuItem, subMenuIndex) => (React.createElement("div", { key: `mobile-nav-item-submenu-item-${subMenuIndex}`, className: `${menuItem.header
                                    ? 'helix-unified-navbar__mobile-menu-header'
                                    : 'helix-unified-navbar__mobile-menu-item helix-unified-navbar__mobile-sub-menu-item'} ${menuItem.url === location ? 'active' : ''} ${menuItem.disabled ? 'disabled' : ''}` },
                                React.createElement(NavbarMobileMenuItem, { linkWrapper: navbarLinkWrapper, ref: (ref) => {
                                        if (menuItems.current &&
                                            menuItems.current.indexOf(ref) > -1 &&
                                            ref) {
                                            menuItems.current.push(ref);
                                        }
                                    }, location: location, item: menuItem }))))))),
                    (customMobileMenu || navItems.length > 0) &&
                        (helpUrl || notificationMenuItems || userMenuItems.length > 0) && (React.createElement("hr", { className: 'helix-unified-navbar__mobile-menu-divider' })),
                    helpUrl && (React.createElement(NavbarMobileHelpItem, { linkWrapper: helpItemLinkWrapper, helpUrl: helpUrl, target: helpTarget })),
                    helpMenuItems && helpMenuItems.length > 0 && (React.createElement(React.Fragment, null,
                        !hideHelpMenuHeader && (React.createElement("div", { className: 'helix-unified-navbar__mobile-menu-header' }, "Help")),
                        helpMenuItems.map((item, userIndex) => {
                            if (item.divider)
                                return (React.createElement("hr", { key: `mobile-help-item-divider-${userIndex}`, className: 'helix-unified-navbar__mobile-menu-divider' }));
                            return (React.createElement("div", { key: `mobile-help-item-${userIndex}`, className: `helix-unified-navbar__mobile-menu-item ${helpMenuLocation === item.url ? 'active' : ''}` },
                                React.createElement(NavbarMobileMenuItem, { linkWrapper: userMenuLinkWrapper, item: item })));
                        }))),
                    userMenuItems.length > 0 && (helpUrl || notificationMenuItems || helpMenuItems) && (React.createElement("hr", { className: 'helix-unified-navbar__mobile-menu-divider' })),
                    userMenuItems.length > 0 && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: 'helix-unified-navbar__mobile-menu-profile-item' },
                            (userInfo === null || userInfo === void 0 ? void 0 : userInfo.avatarURL) ? (React.createElement("div", { className: 'helix-unified-nav__user-avatar' },
                                React.createElement("img", { src: userInfo.avatarURL, alt: 'avatar' }))) : (React.createElement(ProfileIcon, null)),
                            ' ',
                            userInfo && (React.createElement("div", { className: 'helix-unified-navbar__mobile-menu-user-info' },
                                userInfo.name && (React.createElement("span", { className: 'helix-unified-navbar__mobile-menu-user-info-name' }, userInfo.name)),
                                userInfo.email && (React.createElement("span", { className: 'helix-unified-navbar__mobile-menu-user-info-email' }, userInfo.email))))),
                        userMenuItems.map((item, userIndex) => {
                            if (item.divider)
                                return (React.createElement("hr", { key: `mobile-user-item-divider-${userIndex}`, className: 'helix-unified-navbar__mobile-menu-divider' }));
                            return (React.createElement("div", { key: `mobile-user-item-${userIndex}`, className: `helix-unified-navbar__mobile-menu-item ${userMenuLocation === item.url ? 'active' : ''}` },
                                React.createElement(NavbarMobileMenuItem, { linkWrapper: userMenuLinkWrapper, item: item })));
                        }))))))));
    return React.createElement(React.Fragment, null);
};

export { NavbarMobileMenu as default };
//# sourceMappingURL=NavbarMobileMenu.js.map
